import { lazy, Suspense } from 'react';
import LoadingCom from '../../components/LoadingCom';
import PageErrorBoundary from '../../components/PageErrorBoundary';

export const fetchTaxSettingsPage = () =>
  import(/* webpackPrefetch: true */ './Index');

const TaxSettingsPage = lazy(fetchTaxSettingsPage);

export default function SuspendedTaxSettingsPage() {
  return (
    <PageErrorBoundary>
      <Suspense fallback={<LoadingCom />}>
        <TaxSettingsPage />
      </Suspense>
    </PageErrorBoundary>
  );
}
